import Repository from './Repository';

export default class CampaignRepository extends Repository {
    protected basePath = 'campaigns';

    protected messages = {
        destroy : this.__('Kampány sikeresen törölve.'),
        store : this.__('Kampány sikeresen létrehozva.'),
        update : this.__('Kampány sikeresen frissítve.'),
    }

    protected redirects = {
        store: { name : 'campaigns' }
    }

    public export(data: object): Promise {
        console.error('Export method does not exist on CampaignRepository.');
    }

    public import(data: object): Promise {
        console.error('Import method does not exist on CampaignRepository.');
    }
}